import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  Grid,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { json, Link, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Scrollbar from 'src/components/scrollbar';
import Iconify from '../../../iconify';
import { string } from 'prop-types';
import Icon from 'src/components/color-utils/Icon';
import { toast } from 'react-hot-toast';

const { PRIVATE_ROUTE } = API_ROUTES;

export default function RatesheetList() {
  const [open, setOpen] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();
  const navigate = useNavigate();
 
  const handleEditRedirect = (e, id) => {
    navigate(`/rate-sheet/update/${id}`);
  };
  const handleRowDelete = async (e, id) => {
    if (confirm('Are you sure want to delete?') === true) {
      setLoading(false);
      const deleteJob = await authAxios.post(`${PRIVATE_ROUTE?.DELETE_RATESHEET}${id}`);
      if (deleteJob.data.statusCode === 400) {
        return toast.error(deleteJob.data.message);
      }
      getUserdata('');
      setOpen(null);
      setLoading(true);
      setSelectedRow(null);
    }
  };
 
  const handlecreateform = () => {
    navigate('/rate-sheet/create');
  };
  const getUserdata = (query) => {
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;
    if (typeof query !== 'string') {
      sort_params = `&sortField=${query.sortField}&sortOrder=${query.sortOrder}&search=${
        query.searchQuery ? query.searchQuery : ''
      }`;
    } else {
      sort_params = `&search=${query}`;
    }
    let isMounted = true;
    const getUsers = async () => {
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_RATESHEET}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}`
      );

      if (isMounted) {
        setUsers(
          data?.data?.map((item, index) => {
            return {
              _id: item._id,
              name: (
                <Link to={`/rate-sheet/view/${item._id}`}>
                  <b>{item.name}</b>
                </Link>
              ),
              labourItem:
                item.billable_line_items?.labourItem === undefined || item.billable_line_items.labourItem.length === 0
                  ? 'No'
                  : 'Yes',
              materialItem:
                item.billable_line_items?.materialItem === undefined ||
                item.billable_line_items.materialItem.length === 0
                  ? 'No'
                  : 'Yes',
              fixItem:
                item.billable_line_items?.fixItem === undefined || item.billable_line_items.fixItem.length === 0
                  ? 'No'
                  : 'Yes',
              active: <Icon color={item.active === true ? 'green' : 'red'} name="people" size={30} />,
            };
          })
        );
        setCount(data.total);
        setLoading(false);
      }
    };
    getUsers().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  };
  useEffect(() => {
    getUserdata('');
  }, [rowsPerPage]);
  const columns = [
    {
      name: '_id',
      label: 'id',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Name',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'labourItem',
      label: 'Labour Cost Items',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'materialItem',
      label: 'Equipment and Materials',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'fixItem',
      label: 'Fixed Price Items',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'active',
      label: 'Active',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: '',
      lable: 'Action',
      options: {
        filter: true,
        display: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              <EditIcon onClick={(e) => handleEditRedirect(e, tableMeta.rowData[0])} />
              <DeleteIcon onClick={(e) => handleRowDelete(e, tableMeta.rowData[0])} />
            </div>
          );
        },
      },
    },
  ];
  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standerd',
    print: true,
    filter: false,
    fixedHeader: true,
    searchOpen: true,
    count: count,
    selectableRows: false,
    downloadOptions: {
      filterOptions:{
        useDisplayedColumnsOnly: true,
      } 
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const formattedData = data.map((item) => {
        if (typeof item === 'string') {
          return item;
        } 
        if (typeof item === 'object' && Array.isArray(item.data)) {
          const result = [];
      
          item.data.forEach(el => {
            if (typeof el !== 'object') {
              result.push(el);
            }
      
            if (typeof el === 'object') {
              if (el.props?.to) {
                result.push(el.props.children.props.children);
              }
      
              if (Array.isArray(el.props?.children)) {
                const childrenArray = el.props.children;
                const combinedString = `${childrenArray[1]}, ${childrenArray[5]}, ${childrenArray[9]}, ${childrenArray[13]}`;
                result.push(combinedString);
              }
            }
          });
      
          return result;
        }
      
        return null;
      });
      const result = formattedData.map((data, index) => ({
        index: index,
        data: data
      }));

      return "\uFEFF" + buildHead(columns) + buildBody(result); 
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          backgroundColor:
            rowIndex % 2 === 0
              ? 'rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15) 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)'
              : 'white',
        },
      };
    },
    setTableProps: () => {
      return {
        padding: 'default',
        border:
          '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15) 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)',
        size: 'small',
      };
    },
   
    onSearchChange: (searchQuery) => {
      if (searchQuery !== null && searchQuery.length > 2) {
        setSearchEnable(searchQuery);
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.name; 
          const sortOrder = sortEnable.direction; 
          getUserdata({ sortField, sortOrder, searchQuery }); 
        } else {
          getUserdata(searchQuery);
        }
        setLoading(true);
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.name; 
          const sortOrder = sortEnable.direction; 

          getUserdata({ sortField, sortOrder }); 
        } else {
          getUserdata('');
        }
      }
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,
  
    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;
      const sortField = name; 
      const sortOrder = direction; 
      let searchQuery = searchEnable;
      let page_no = tableState.page;
      if (action === 'sort') {
        setSortEnable(tableState.sortOrder);
        if (searchEnable) {
          getUserdata({ sortField, sortOrder, searchQuery, page_no }); 
        } else {
          getUserdata({ sortField, sortOrder, page_no }); 
        }
      }
      if (action === 'changePage') {
        setPage(tableState.page);
        if (searchEnable) {
          getUserdata({ sortField, sortOrder, searchQuery, page_no }); 
        } else {
          getUserdata({ sortField, sortOrder, page_no }); 
        }
      }
    },
  };

  return (
    <>
      <Grid sx={{ p: 4, pb: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Rate Sheet
          </Typography>
          <Button variant="contained" onClick={handlecreateform} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Rate Sheet
          </Button>
        </Stack>
        <Grid>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <MUIDataTable options={options} columns={columns} data={users} />
                
                {loading && (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}

                {!users && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </>
  );
}
